import { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MapPin } from 'lucide-react';

const NOTIFICATIONS = [
  { name: 'Maria G.', city: 'Buenos Aires', action: 'evaluation' },
  { name: 'Robert S.', city: 'New York', action: 'evaluation' },
  { name: 'Carlos M.', city: 'São Paulo', action: 'certificate' },
  { name: 'Anna K.', city: 'Sydney', action: 'evaluation' },
  { name: 'Jean-Pierre L.', city: 'Montreal', action: 'research' },
  { name: 'Isabella R.', city: 'Melbourne', action: 'evaluation' },
  { name: 'Diego F.', city: 'Rosario', action: 'certificate' },
  { name: 'Patricia W.', city: 'London', action: 'evaluation' },
  { name: 'Michael T.', city: 'Chicago', action: 'research' },
  { name: 'Lucia V.', city: 'Montevideo', action: 'evaluation' },
  { name: 'Thomas B.', city: 'Toronto', action: 'certificate' },
  { name: 'Elena P.', city: 'Madrid', action: 'evaluation' },
];

const SocialProofNotification = () => {
  const { language } = useLanguage();
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  const actionText = {
    it: { evaluation: 'ha richiesto una valutazione gratuita', certificate: 'ha generato un certificato', research: 'ha avviato una ricerca genealogica' },
    en: { evaluation: 'requested a free evaluation', certificate: 'generated a certificate', research: 'started genealogical research' },
    es: { evaluation: 'solicitó una evaluación gratuita', certificate: 'generó un certificado', research: 'inició una investigación genealógica' },
    pt: { evaluation: 'solicitou uma avaliação gratuita', certificate: 'gerou um certificado', research: 'iniciou uma pesquisa genealógica' },
  };

  const timeAgo = {
    it: ['2 minuti fa', '5 minuti fa', '8 minuti fa', '12 minuti fa', '15 minuti fa'],
    en: ['2 minutes ago', '5 minutes ago', '8 minutes ago', '12 minutes ago', '15 minutes ago'],
    es: ['hace 2 minutos', 'hace 5 minutos', 'hace 8 minutos', 'hace 12 minutos', 'hace 15 minutos'],
    pt: ['há 2 minutos', 'há 5 minutos', 'há 8 minutos', 'há 12 minutos', 'há 15 minutos'],
  };

  useEffect(() => {
    if (dismissed) return;
    const alreadyShown = sessionStorage.getItem('socialProofShown');
    
    const showNotification = () => {
      const randomIdx = Math.floor(Math.random() * NOTIFICATIONS.length);
      const randomTime = Math.floor(Math.random() * (timeAgo[language] || timeAgo.it).length);
      setCurrent({ ...NOTIFICATIONS[randomIdx], time: (timeAgo[language] || timeAgo.it)[randomTime] });
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };

    const initialDelay = alreadyShown ? 45000 : 8000;
    const timer = setTimeout(() => {
      showNotification();
      sessionStorage.setItem('socialProofShown', 'true');
    }, initialDelay);

    const interval = setInterval(showNotification, 55000);

    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, [language, dismissed]);

  if (!visible || !current || dismissed) return null;

  const lang = actionText[language] || actionText.it;

  return (
    <div
      data-testid="social-proof-notification"
      className="fixed bottom-20 left-4 z-40 animate-in slide-in-from-left duration-500"
      style={{ maxWidth: '340px' }}
    >
      <div className="bg-white rounded-xl shadow-xl border border-gray-100 p-4 relative">
        <button
          onClick={() => { setVisible(false); setDismissed(true); }}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-xs w-5 h-5 flex items-center justify-center"
          data-testid="social-proof-dismiss"
          aria-label="Close"
        >
          x
        </button>
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
            <MapPin className="w-5 h-5 text-green-600" />
          </div>
          <div>
            <p className="text-sm text-gray-800 font-medium leading-snug">
              <span className="font-bold">{current.name}</span>{' '}
              <span className="text-gray-500">
                {language === 'it' ? 'da' : language === 'es' ? 'de' : language === 'pt' ? 'de' : 'from'}{' '}
                {current.city}
              </span>{' '}
              {lang[current.action]}
            </p>
            <p className="text-xs text-gray-400 mt-1">{current.time}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialProofNotification;
